import { render, staticRenderFns } from "./RelateOrder.vue?vue&type=template&id=ec554158&scoped=true"
import script from "./RelateOrder.vue?vue&type=script&lang=js"
export * from "./RelateOrder.vue?vue&type=script&lang=js"
import style0 from "./RelateOrder.vue?vue&type=style&index=0&id=ec554158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec554158",
  null
  
)

export default component.exports